export type ExplorePathParams = [
	string | undefined,
	string | undefined,
	string | undefined,
	string | undefined,
	string | undefined,
	string | undefined,
]

export function toExplorePath(
	country: string | undefined,
	region?: string,
	type?: string,
	trailSlug?: string,
	captureSlug?: string,
	frameId?: string,
) {
	return ['/explore', country, region, type, trailSlug, captureSlug, frameId]
		.filter(Boolean)
		.join('/')
}
